import React, { useState } from 'react';
import { Grid, Typography, Snackbar, IconButton, Slide, Divider, Stack, Paper, Button, styled } from '@mui/material';
import { useLocale } from '../../context/LocaleContext';
import CustomButton from '../Base/CustomButton';
import { useDropzone } from 'react-dropzone';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import Filter1OutlinedIcon from '@mui/icons-material/Filter1Outlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

function SlideTransition(props) {
	return <Slide {...props} />;
}

const UploadButton = styled(Button)(() => ({
	backgroundColor: 'rgba(243, 249, 199, 0.4)',
	color: '#212121',
	borderRadius: '10px',
	boxShadow: 'none',
	textTransform: 'none',
	'&:hover': {
		backgroundColor: 'rgba(243, 249, 199, 0.5)',
		borderRadius: '5px',
	}
}));


const UploadComponent = ({ setUploadedFile, phoneDisplay }) => {
	const { messages } = useLocale();
	const [errorMessage, setErrorMessage] = useState('');
	const [open, setOpen] = useState(false);

	const { getRootProps, getInputProps, isDragActive, open: openFileDialog } = useDropzone({
		accept: { 'image/*': [] },
		maxSize: 10 * 1024 * 1024,
		multiple: false,
		noClick: true,
		onDrop: (acceptedFiles, fileRejections) => {
			// Handle accepted files
			if (acceptedFiles.length > 0) {
				console.log('Accepted files:', acceptedFiles);
				setUploadedFile(acceptedFiles[0]); // Store the uploaded file
				setErrorMessage('');
			}

			// Handle rejected files
			if (fileRejections.length > 0) {
				const errors = fileRejections.map(rejection => {
					return rejection.errors.map(e => e.message).join(', ');
				}).join('. ');
				setErrorMessage(`File upload error: ${errors}`);
				setOpen(true);
			}
		}
	});

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpen(false);
	};

	return (
		<>
			{phoneDisplay ?
				<UploadButton variant='text' fullWidth>
					<input {...getInputProps()} type="file" accept="image/*" on />
					<Stack direction='column' alignItems='center' gap={1} justifyContent='center' sx={{ height: '100%', width: 'max-content' }}>
						<Paper {...getRootProps()} sx={{ textAlign: 'center', backgroundColor: 'transparent' }} elevation={0}>
						<Grid container gap={2}>
							<Grid item xs={1}><Filter1OutlinedIcon /></Grid>
							<Grid item xs={9}><Typography>{messages.homepage.upload.info[0]}</Typography></Grid>
						</Grid>
						<Grid container gap={2}>
							<Grid item xs={1}><ImageOutlinedIcon /></Grid>
							<Grid item xs={9}><Typography>{messages.homepage.upload.info[1]}</Typography></Grid>
						</Grid>
						<Grid container gap={2}>
							<Grid item xs={1}><CloudUploadOutlinedIcon /></Grid>
							<Grid item xs={9}><Typography>{messages.homepage.upload.info[2]}</Typography></Grid>
						</Grid>
						</Paper>
					</Stack>
				</UploadButton>
				:
				<Grid container>
					<Grid item xs={0} sm={1} md={0.25} lg={0.5}></Grid>
					<Grid item xs={4} sm={4} md={4} lg={4}>
						<input {...getInputProps()} />
						<Stack direction='column' alignItems='center'>
							<Paper {...getRootProps()} sx={{ textAlign: 'center', backgroundColor: 'transparent' }} elevation={0}>
								<input {...getInputProps()} />
								<FileUploadOutlinedIcon sx={{ fontSize: 50, color: '#F5B60B' }} />
								<Typography fontSize={15} fontWeight={600} align='center'>{messages.homepage.upload.drag}</Typography>
								<Divider flexItem sx={{ marginTop: 4, marginBottom: 4, color: '#3B3F46', borderColor: '#3B3F46' }}>{messages.common.or}</Divider>
								<CustomButton sx={{ width: 'min(180px, 100%)', height: 40 }} onClick={openFileDialog}>{messages.homepage.upload.button}</CustomButton>
							</Paper>
						</Stack>
					</Grid>
					<Grid item xs={0.5} sm={1} md={0.5} lg={1}></Grid>
					<Grid item xs={7.5} sm={5} md={7} lg={6} alignItems='center'>
						<Stack direction='column' alignItems='center' gap={3} justifyContent='center' sx={{ height: '100%' }}>
							<Grid container gap={2}>
								<Grid item xs={1}><Filter1OutlinedIcon /></Grid>
								<Grid item xs={9}><Typography>{messages.homepage.upload.info[0]}</Typography></Grid>
							</Grid>
							<Grid container gap={2}>
								<Grid item xs={1}><ImageOutlinedIcon /></Grid>
								<Grid item xs={9}><Typography>{messages.homepage.upload.info[1]}</Typography></Grid>
							</Grid>
							<Grid container gap={2}>
								<Grid item xs={1}><CloudUploadOutlinedIcon /></Grid>
								<Grid item xs={9}><Typography>{messages.homepage.upload.info[2]}</Typography></Grid>
							</Grid>
						</Stack>
					</Grid>
					<Grid item xs={0} sm={1} md={0.25} lg={0.5}></Grid>
				</Grid>
			}
			<Snackbar
				open={open}
				autoHideDuration={5000}
				onClose={handleClose}
				TransitionComponent={SlideTransition}
				action={
					<IconButton
						size="small"
						aria-label="close"
						color="inherit"
						onClick={handleClose}
					>
						<CloseIcon fontSize="small" />
					</IconButton>
				}
				message={errorMessage}
			/>
		</>
	);
};

export default UploadComponent;
